import cloneDeep from 'lodash/cloneDeep';
export let adyenConfig;
export let adyenPaymentMethodConfig;
export const updateConfigs = () => {
    adyenConfig = cloneDeep(Object.assign({}, window.AdyenConfiguration));
    adyenPaymentMethodConfig = cloneDeep(Object.assign({}, window.PaymentMethodConfiguration));
};
